<template>
  <div>
    <material-card :title="title" :color="$vuetify.theme.themes.light.success" icon="add">
      <v-card-text style="margin-top:20px">
        <pbas-data-table
          v-if="provider !== null && provider !== undefined"
          ref="table"
          :dataProvider="provider"
          identifier="selfPaymentsAddMany"
          @error="error = $event"
          :showSelect="false"
          :floatActions="floatActions"
          :rowActions="rowActions"
        >
          <template
            v-for="(header, index) in provider.headers"
            v-slot:[itemSlotFunc(header)]="{ header, item }"
          >
            <div
              v-bind:key="header.type.key"
              v-if="header.type.key === 'PaymentDate'"
              style="justify-content:center"
            >
              <v-btn small text @click.prevent="rowActions[0].handler(item)">
                <v-icon>
                  {{ rowActions[0].icon }}
                </v-icon>
                {{ $t(rowActions[0].title) }}
              </v-btn>
              <pbas-date-picker
                style="min-width: 200px"
                :value="item.PaymentDate"
                @update-date="updateRow($event, item, 'PaymentDate')"
                :rules="[$rules.required]"
                :class="'required'"
              ></pbas-date-picker>
            </div>
            <trans-select2
              v-bind:key="header.type.key"
              v-if="header.type.key === 'Term/Translations[]/Name'"
              :value="item"
              propertyName="Term"
              :items="terms"
              field="Name"
              itemValue="Id"
              :rules="[$rules.required]"
              class="required"
              @change="updateRow($event, item, 'Term')"
              :displayFunc="(item, str) => `${trans2(item, 'FullName')}`"
            ></trans-select2>
            <currency-textfield
              v-bind:key="header.type.key"
              v-if="header.type.key === 'Amount'"
              v-model="item.Amount"
              :class="'required'"
              :rules="[$rules.requiredNum]"
              style="min-width: 200px"
              @change="updateRow($event, item, 'Amount')"
            />
            <!-- <no-autocomplete-textfield
              v-bind:key="header.type.key"
              v-if="header.type.key === 'Amount'"
              v-model="item.Amount"
              :class="'required'"
              :rules="[$rules.requiredNum, $rules.decimal]"
              @keydown="currencyKeydown"
              @keyup="currencyKeyUp"
              @blur="amountBlur"
              prefix="$"
              @change="updateRow($event, item, 'Amount')"
            ></no-autocomplete-textfield> -->
            <div
              v-bind:key="header.type.key"
              v-if="header.type.key === 'Deposited'"
              style="margin:0 auto 15px;!important"
            >
              <v-checkbox
                v-model="item.Deposited"
                @change="updateRow($event, item, 'Deposited')"
              />
            </div>
          </template>
        </pbas-data-table>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-btn text @click="$emit('close')">{{ $t("globals.cancel") }}</v-btn>
        <v-btn
          :disabled="!valid"
          color="primary"
          :loading="saving"
          @click="save"
        >
          {{ $t("globals.save") }}
        </v-btn>
      </v-card-actions>
    </material-card>
    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ErrorHandler from "../components/ErrorHandler";
import NoAutocompleteTextfield from "../components/NoAutocompleteTextfield";
import TransSelect2 from "../components/TransSelect2";
import InMemorySelfPaymentsHeaders from "../headers/InMemorySelfPayments";
import { InMemoryProvider } from "pbas-vue-components";
import CurrencyTextfield from '../components/CurrencyTextfield.vue';
import { translate2 } from "../trans2";
export default {
  components: {
    ErrorHandler,
    NoAutocompleteTextfield,
    TransSelect2,
    CurrencyTextfield
  },
  props: {
    title: String,
    employerId: String,
    memberIdentityId: String,
  },
  data() {
    return {
      rowActions: [
        {
          title: "globals.delete",
          name: "delete",
          icon: "delete",
          handler: (item) => {
            this.provider.items = this.provider.items.filter(
              (o) => o.Identifier !== item.Identifier
            );
            this.$refs.table.getDataAsync();
          },
        },
      ],
      floatActions: [
        {
          text: "components.memberselfpaymentsaddmany.add_row",
          color: this.$vuetify.theme.themes.light.success,
          name: "add",
          icon: "add",
          handler: () => {
            this.provider.items.push({
              Identifier: Math.random().toString(),
              MemberId: this.memberIdentityId,
              PlanId: this.selectedPlan.Id,
              TermId: null,
              PaymentDate: null,
              Amount: null,
              CreatedAt: null,
              ChangedAt: null,
              DeletedAt: null,
              Deposited: false,
            });
            this.$refs.table.getDataAsync();
          },
        },
      ],
      provider: undefined,
      valid: true,
      error: null,
      saving: false,
      terms: [],
    };
  },
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("plansMembers", ["options"]),
  },
  methods: {
    ...mapActions("plansMembers", [
      "addManyMemberSelfPayments",
      "getMemberByEffectiveDate",
    ]),
    trans2(item, property) {
      return translate2(item, property);
    },
    updateRow(value, row, key) {
      if (key === "PaymentDate") {
        if (value !== null && value !== undefined) {
          this.loadEmployerAndTerms(value);
        }
      }
      const index = this.provider.items.indexOf(
        this.provider.items.filter((o) => o.Identifier === row.Identifier)[0]
      );
      this.provider.items[index][key] = value;
      this.valid = this.validate();
    },
    validate() {
      let valid = true;
      for (let item of this.provider.items) {
        valid = this.isValid(item);
        if (!valid) {
          return false;
        }
      }
      console.log("valid: ", valid);
      return valid;
    },
    isValid(item) {
      return (
        item.PaymentDate !== null &&
        item.PaymentDate !== undefined &&
        item.PaymentDate !== "" &&
        item.Term !== null &&
        item.Term !== undefined &&
        item.Amount !== null &&
        item.Amount !== undefined
      );
    },
    itemSlotFunc(header) {
      return "item." + header.type.key;
    },
    async save() {
      this.error = null;
      this.saving = true;
      try {
        let items = JSON.parse(JSON.stringify(this.provider.items));
        for (let item of items) {
          if (item.Term) {
            item.CalendarMonth = item.Term.CalendarMonth;
            item.CalendarYear = item.Term.CalendarYear;
            delete item.Term;
          }
          item.Amount = parseFloat(item.Amount); //.toFixed(2);
          // item.CreatedAt = this.$helpers.nowFormatted();
          delete item.Identifier;
        }

        await this.addManyMemberSelfPayments({
          planIdentityId: this.selectedPlan.Id,
          memberIdentityId: this.memberIdentityId,
          payload: items,
        });
        this.$emit("save");
      } catch (e) {
        console.error(e);
        this.error = e;
      }
      this.saving = false;
    },
    async loadEmployerAndTerms(effectiveDate) {
      try {
        this.loading = true;
        this.member = (
          await this.getMemberByEffectiveDate({
            planIdentityId: this.selectedPlan.Id,
            memberIdentityId: this.memberIdentityId,
            effectiveDate: effectiveDate,
            odataQuery:
              "$select=Id,&$expand=CurrentMember($select=DateOfBirth),CurrentEmploymentInformation($select=EmployerId,HireDate),CurrentMembershipStatus($select=MemberGroupIdentityId)",
          })
        ).data;
        let employerId = this.member.CurrentEmploymentInformation.EmployerId;
        let terms = (
          await this.getEmployerContributionTerms({
            planIdentityId: this.selectedPlan.Id,
            employerId: employerId,
          })
        ).data.value;
        this.terms = terms.filter(
          (value, index, self) =>
            index ===
            self.findIndex(
              (t) =>
                t.CalendarMonth === value.CalendarMonth &&
                t.CalendarYear === value.CalendarYear
            )
        );
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
  },
  async mounted() {
    try {
      this.loading = true;
      this.provider = new InMemoryProvider(
        [
          {
            Identifier: Math.random().toString(),
            MemberId: this.memberIdentityId,
            PlanId: this.selectedPlan.Id,
            TermId: null,
            PaymentDate: null,
            Amount: null,
            CreatedAt: null,
            ChangedAt: null,
            Deposited: false,
          },
        ],
        InMemorySelfPaymentsHeaders
      );
    } catch (error) {
      this.error = error;
    } finally {
      this.loading = false;
    }
  },
  watch: {},
};
</script>
